<app-loading-bar></app-loading-bar>
<div class="c-wrapper" dynamicTheme [currentTheme]="themeEmitter">
  <main *ngIf="isLoggedIn else login">
    <app-site-header
      class="c-site-header"
      id="c-site-header"
      [siteLeftPanel]="siteLeftPanel"
      [siteRightPanel]="siteRightPanel"
    ></app-site-header>
    <mat-sidenav-container [hasBackdrop]="false">
      <mat-sidenav
        class="c-site-left-panel"
        id="c-site-left-panel"
        #siteLeftPanel
        mode="side"
        (openedChange)="drawerOpenEvent($event)"
        opened
      >
        <app-left-panel-container></app-left-panel-container>
      </mat-sidenav>

      <mat-sidenav
        class="c-site-right-panel"
        id="c-site-right-panel"
        #siteRightPanel
        mode="over"
        position="end"
      >
        <app-right-panel></app-right-panel>
      </mat-sidenav>
      <mat-sidenav-content class="c-site-middle-content">
        <app-site-middle-content [ngClass]="isLeftPanelOpend ? 'c-with-left-panel':''">
        </app-site-middle-content>
      </mat-sidenav-content>
    </mat-sidenav-container>
    <div
      *ngIf="env.displayEnvName"
      class="u-text-center c-environment-status "
      [ngClass]="enviornmentClass"
    >
      {{ env.environmentName | uppercase }}
    </div>
  </main>
  <main>
    <ng-template #login>
      <router-outlet> </router-outlet>
    </ng-template>
  </main>
  <button id="c-go-to-top" class="c-go-to-top" *ngIf="isShow" (click)="gotoTop()">
    <mat-icon>arrow_upward</mat-icon>
  </button>

  <ng-idle-box [idleMessage]="idleMessage"></ng-idle-box>
</div>
